import {
  mapper,
} from '@shared/lib';

export type HowItWorksBlockItem = {
  iconSrc: Maybe<Url>;
  details: string;
};

export type HowItWorksBlock = {
  title?: Maybe<string>;
  items?: Maybe<Array<HowItWorksBlockItem>>
};

type MapHowItWorksBlockItem = (data: any) => HowItWorksBlockItem;
export const mapHowItWorksBlockItem: MapHowItWorksBlockItem = mapper([
  { name: 'iconSrc', from: 'iconSrc.data.attributes.url' },
  { name: 'details', from: 'details' },
]);